<template>
    <div class="user-lists-modal add-trip-dates-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Title -->
            <h2>Add Trip Dates</h2>

            <!-- Form -->
            <form v-if="form" :action="formUrl" @submit.prevent="submit" method="post">

                <div class="trip-picker-navbar">
                    <button type="button" @click="toogleTripDays(false)" :class="{'active' : !selectTripDays }">
                        DD/MM/YYYY
                    </button>
                    <button type="button" @click="toogleTripDays(true)" :class="{'active' : selectTripDays }">
                        Days (Day 1)
                    </button>
                </div>

                <p v-if="selectTripDays" class="text-info">How many days is your trip?</p>
                <p v-else class="text-info">Select your dates</p>

                <div v-if="selectTripDays" class="trip-box trip-days-selector">

                    <div class="days-input">
                        <button type="button" @click="decreaseTripDays()" :disabled="form.trip_days <= 0">
                            <svg class="minus-circle"><use xlink:href="#minus-circle"></use></svg>
                        </button>
                        <input type="number" v-model="form.trip_days">
                        <button type="button" @click="increaseTripDays()" :disabled="form.trip_days == 31">
                            <svg class="plus-circle"><use xlink:href="#plus-circle"></use></svg>
                        </button>
                    </div>

                </div>

                <div v-else class="trip-box trip-date-selector">
                    <trip-date-selector v-model="form" :inline="true"></trip-date-selector>
                </div>

                <div class="btn-actions">

                    <button type="button" class="btn-clear" @click="clearSelection()" v-if="!selectTripDays">
                        Clear Selection
                    </button>

                    <button class="btn-submit" type="submit">
                    <span v-if="form && form.trip_days != null"
                          v-text="`Confirm ${form.trip_days} ${pluralize('day', form.trip_days)}`">
                    </span>
                        <span v-else>Confirm 0 Days</span>
                    </button>
                </div>
            </form>
        </div>

    </div>
</template>
<script>

import Form from "@/classes/Form"
import Helpers from "@/mixins/Helpers"
import TripDateSelector from "@/components/Lists/TripDateSelector"

export default {

    mixins: [Helpers],

    components: {
        TripDateSelector
    },

    props: ['list'],

    data() {
        return {
            currentList: this.list,
            selectTripDays: false,
            triggeredFrom: null,
            form: null
        }
    },

    created() {
        this.createForm()
    },

    mounted() {
        eventBus.$on('open-add-dates-to-list-dialog', event => {
            if(event && event.hasOwnProperty('form')) {
                this.form = new Form({
                    name: event.form.name,
                    secret: event.form.secret,
                    trip_date: event.form.trip_date,
                    trip_days: event.form.trip_days,
                }).dontClear()
            }
            this.openModal(event)
        })
    },

    methods: {

        submit() {

            if (this.triggeredFrom) {
                this.closeWithoutServerRequest()
                return
            }

            if (this.currentList) {
                this.form.patch(`/${this.currentList.user.username}/lists/${this.currentList.id}`)
                    .then(response => {
                        eventBus.$emit('list-updated', response)
                        eventBus.$emit('fetch-schedule')
                        this.closeModal()
                    })
                    .catch(errors => {
                        console.error(errors)
                    })
            }
        },

        createForm() {
            if (this.currentList) {
                this.form = new Form({
                    name: this.currentList.name,
                    secret: this.currentList.secret,
                    trip_date: this.currentList.trip_date,
                    trip_days: (this.currentList && this.currentList.trip_days) ? this.currentList.trip_days : 0
                }).dontClear()
            }
        },

        closeWithoutServerRequest() {
            this.closeModal()
            return
        },

        toogleTripDays(value) {
            this.selectTripDays = value
            if (this.selectTripDays) {
                this.form.trip_days = (this.currentList && this.currentList.trip_days) ? this.currentList.trip_days : 0
                this.form.trip_date = null
            } else {
                this.form.trip_date = this.currentList.trip_date
                this.form.trip_days = (this.currentList && this.currentList.trip_days) ? this.currentList.trip_days : null
            }
        },

        clearSelection() {
            this.form.trip_days = this.selectTripDays ? 1 : null
            this.form.trip_date = null
        },

        openModal(event) {
            if (event && event.hasOwnProperty('from')) {
                this.triggeredFrom = event.from
            }
            this.$nextTick(() => {
                $('.add-trip-dates-list-dialog').fadeIn()
                let timeout = setTimeout(() => {
                    document.body.classList.add('no-scroll')
                    clearTimeout(timeout)
                }, 500)
            })
        },

        closeModal() {
            this.$nextTick(() => {
                $('.add-trip-dates-list-dialog').fadeOut();
                document.body.classList.remove('no-scroll')
            })
            if (this.triggeredFrom) {
                console.log(this.triggeredFrom)
                eventBus.$emit(this.triggeredFrom, {
                    trip_date: this.form.trip_date,
                    trip_days: this.form.trip_days
                })
                this.triggeredFrom = null
            } else {
                eventBus.$emit('list-updated', {
                    list: this.currentList
                })
            }
        },

        increaseTripDays() {
            if (this.form.trip_days < 31) {
                this.form.trip_days++
            }
        },

        decreaseTripDays() {
            if (this.form.trip_days > -1) {
                this.form.trip_days--
            }
        }
    },

    computed: {
        formUrl() {
            if (this.currentList) {
                return `/${this.currentList.user.username}/lists/${this.currentList.id}`
            }

            return '/#choose-dates'
        }
    }
}
</script>
